var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnPriceDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.56413 5.3897C3.22707 5.63045 3.149 6.09887 3.38976 6.43593L7.77595 12.5766C8.35949 13.3935 9.50925 13.5531 10.2932 12.926L13.5445 10.3249C13.6653 10.2283 13.844 10.2635 13.9192 10.3988L17.3542 16.5818L15.2634 15.7978C14.8756 15.6523 14.4433 15.8488 14.2978 16.2367C14.1524 16.6245 14.3489 17.0568 14.7367 17.2022L18.7367 18.7022C18.9368 18.7773 19.1595 18.7634 19.3487 18.664C19.538 18.5646 19.6758 18.3893 19.7277 18.1819L20.7277 14.1819C20.8281 13.7801 20.5838 13.3729 20.182 13.2724C19.7801 13.1719 19.3729 13.4162 19.2725 13.8181L18.7332 15.9752L15.2304 9.67029C14.7044 8.72343 13.4532 8.47699 12.6074 9.15364L9.35616 11.7546C9.24417 11.8442 9.07991 11.8214 8.99655 11.7047L4.61036 5.56407C4.3696 5.22701 3.90119 5.14894 3.56413 5.3897Z",
    fill: "#00322E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPriceDrop);
export default __webpack_public_path__ + "static/media/icn_price-drop.7710cb690fcdac8fd5e25f9b9f0f3449.svg";
export { ForwardRef as ReactComponent };